import { defineMessages } from 'react-intl';

export const itemsMessages = defineMessages({
  editItem: {
    id: 'items.settings.edit-item',
    defaultMessage: 'Edit item',
  },
});

export const skuItemsGroupMessages = defineMessages({
  payout: {
    id: 'items.items-group.header.payout',
    defaultMessage: 'Payout',
  },
  availability: {
    id: 'items.items-group.header.availability',
    defaultMessage: 'Item availability',
  },
  payoutTooltip: {
    id: 'items.items-group.header.payout-tooltip',
    defaultMessage:
      'Your payout is calculated based on your listed menu price for this item. For item tax clarifications, please see <a>here</a>.',
  },
  editItemAriaLabel: {
    id: 'items.items-group.button.edit-item-aria-label',
    defaultMessage: 'Edit item {itemName}',
  },
  itemActionsAriaLabel: {
    id: 'items.items-group.button.item-actions-aria-label',
    defaultMessage: 'Item actions for {itemName}',
  },
});

export const skuVenueOpenStatusMessages = defineMessages({
  venueStatusHidden: {
    id: 'sku-items.venue-status.hidden',
    defaultMessage: 'Hidden on ClassPass',
  },
  venueStatusPausedForToday: {
    id: 'sku-items.venue-status.paused-for-today',
    defaultMessage: 'Pause orders for today',
  },
  venueStatusOpen: {
    id: 'sku-items.venue-status.open',
    defaultMessage: 'Open',
  },
  venueOpenStatusLoadError: {
    id: 'sku-items.venue-status.load-error',
    defaultMessage: 'There was an error loading the venue open status. Please try again later.',
  },
  storeClosedSuccess: {
    id: 'sku-items.venue-status.store-closed-success',
    defaultMessage: 'Your store is closed for today',
  },
  storeOpenSuccess: {
    id: 'sku-items.venue-status.store-open-success',
    defaultMessage: 'Your store is open for today',
  },
  storeClosedErrorTitle: {
    id: 'sku-items.venue-status.store-closed-error-title',
    defaultMessage: '<strong>We were unable to close your store</strong>',
  },
  storeOpenErrorTitle: {
    id: 'sku-items.venue-status.store-open-error-title',
    defaultMessage: '<strong>We were unable to open your store</strong>',
  },
  storeClosedErrorDescription: {
    id: 'sku-items.venue-status.store-closed-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
  storeOpenErrorDescription: {
    id: 'sku-items.venue-status.store-open-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
});

export const itemsGroupMessages = skuItemsGroupMessages;

export const skuCategorySectionMessages = defineMessages({
  categoryOptionsAriaLabel: {
    id: 'sku-category-section--category-options-aria-label',
    defaultMessage: 'Options for {categoryName}',
  },
  editCategory: {
    id: 'sku-category-section--edit-category',
    defaultMessage: 'Edit category',
  },
  duplicateCategory: {
    id: 'sku-category-section--duplicate-category',
    defaultMessage: 'Duplicate category',
  },
  disableCategory: {
    id: 'sku-category-section--disable-category',
    defaultMessage: 'Disable category',
  },
  enableCategory: {
    id: 'sku-category-section--enable-category',
    defaultMessage: 'Enable category',
  },
});

export const skuCategoryGroupMessages = defineMessages({
  disabledCategoryTooltip: {
    id: 'sku.category-group.disabled-tooltip',
    defaultMessage: 'This category is disabled and is not visible on any of your menus.',
  },
});

export const skuMenuSectionMessages = defineMessages({
  disabledMenuTooltip: {
    id: 'sku.menu-section.disabled-tooltip',
    defaultMessage: 'This menu is disabled and is not visible to customers.',
  },
});

export const skuItemAvailabilityStatusMessages = defineMessages({
  itemStatusAvailable: {
    id: 'items.item-availability-status.available',
    defaultMessage: 'Available',
  },
  itemStatusUnavailableToday: {
    id: 'items.item-availability-status.unavailable-today',
    defaultMessage: 'Unavailable today',
  },
  itemStatusUnavailableIndefinitely: {
    id: 'items.item-availability-status.unavailable-indefinitely',
    defaultMessage: 'Unavailable indefinitely',
  },
  itemStatusPending: {
    id: 'items.item-availability-status.pending',
    defaultMessage: 'Pending review',
  },
});
